const { dateUtil, helpers } = require("../../utils");

export const columns = [
  {
    title: "Name",
    dataIndex: "userId",
    key: "userId",
    render: (userId) => {
      return (
        <p>
          {userId?.first_name} {userId?.last_name}
        </p>
      );
    },
  },
  {
    title: "Plan Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Plan Type",
    dataIndex: "type",
    key: "type",
  },
  {
    title: "Contribution",
    dataIndex: "contribution",
    key: "contribution",
    render: (value) => <p>{helpers.toCurrency(value)}</p>,
  },
  {
    title: "Balance",
    dataIndex: "balance",
    key: "balance",
    render: (balance) => <p>{helpers.toCurrency(balance)}</p>,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
  },

  {
    title: "Total Withdrawan",
    dataIndex: "totalAmountWithdrawn",
    key: "totalAmountWithdrawn",
    render: (value) => <p>{helpers.toCurrency(value)}</p>,
  },
  {
    title: "Creation Date",
    dataIndex: "createdAt",
    key: "createdAt",
    render: (createdAt) => <p>{dateUtil.formatFullDateTime(createdAt)}</p>,
  },
  {
    title: "Start Date",
    dataIndex: "startDate",
    key: "startDate",
    render: (startDate) => <p>{dateUtil.formatFullDateTime(startDate)}</p>,
  },
  {
    title: "End Date",
    dataIndex: "expectedEndDate",
    key: "expectedEndDate",
    render: (expectedEndDate) => (
      <p>{dateUtil.formatFullDateTime(expectedEndDate)}</p>
    ),
  },
  {
    title: "Actions",
    key: "actions",
  },
];
